module.exports = __webpack_public_path__ + "img/task-12-g.fef38520.png";